<script setup>
import { ref } from 'vue';

const props = defineProps({
    label: String,
    inputId: String,
    text: {
        type: String,
        default: 'Opslaan',
    },
    savingText: {
        type: String,
        default: 'Opslaan...',
    },
});

const button = ref(null);

const text = ref(props.text);

const saving = ref(false);

function setSaving(state) {
    saving.value = state;

    if (state) {
        button.value.setAttribute('disabled', 'disabled');
    } else {
        button.value.removeAttribute('disabled');
    }

    text.value = state ? props.savingText : props.text;
}

defineExpose({
    setSaving,
});
</script>

<template>
    <button ref="button" type="submit" 
    class="cursor-pointer font-roboto transform hover:-translate-y-px active:translate-y-0 transition duration-200">
        <span v-if="saving">
            <font-awesome-icon :icon="['fas', 'spinner']" class="animate-spin mr-1" />
        </span>
        {{ text }}
    </button>
</template>